import { useLocation, useNavigate } from "react-router-dom";
import { Home, Globe, Settings, Menu } from "lucide-react";
import { SaraLogo } from "./SaraLogo";

// Primary navigation for the SARA CONNOR shell.
// variant="sidebar" → desktop left rail · variant="bottom" → mobile tab bar.
export function AppNav({ variant = "sidebar", onOpenSettings, onOpenWeb, onOpenMenu, saraReady = true }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (variant === "bottom") {
    const items = [
      { id: "home", label: "Accueil", icon: Home, onClick: () => navigate("/"), active: pathname === "/" },
      { id: "web", label: "Web", icon: Globe, onClick: onOpenWeb, active: false },
      { id: "menu", label: "Menu", icon: Menu, onClick: onOpenMenu, active: false },
    ];
    return (
      <nav data-testid="app-bottom-nav" className="md:hidden shrink-0 sara-bottomnav flex items-center justify-around px-2 h-16">
        {items.map(({ id, label, icon: Icon, onClick, active }) => (
          <button
            key={id}
            data-testid={`bottomnav-${id}`}
            onClick={onClick}
            className={`flex flex-col items-center gap-1 px-3 py-1 rounded-xl transition-colors ${active ? "text-cyan-300" : "text-slate-400"}`}
          >
            <Icon className="h-5 w-5" strokeWidth={1.75} />
            <span className="text-[10px] tracking-wide">{label}</span>
            {active && <span className="h-0.5 w-5 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(0,240,255,0.8)]" />}
          </button>
        ))}
      </nav>
    );
  }

  const sideItems = [
    { id: "home", label: "Accueil", icon: Home, onClick: () => navigate("/"), active: pathname === "/" },
    { id: "web", label: "Web", icon: Globe, onClick: onOpenWeb, active: false },
    { id: "settings", label: "Paramètres", icon: Settings, onClick: onOpenSettings, active: false },
  ];
  return (
    <aside data-testid="app-sidebar" className="hidden md:flex w-60 shrink-0 sara-sidebar flex-col justify-between p-4">
      <div>
        <div className="flex items-center gap-3 px-2 pb-7">
          <SaraLogo className="h-9 w-9" />
          <div className="leading-tight">
            <div className="font-jb text-sm font-bold tracking-[0.2em] text-white">SARA</div>
            <div className="font-jb text-[10px] tracking-[0.34em] text-cyan-400/80">CONNOR</div>
          </div>
        </div>
        <nav className="flex flex-col gap-1.5">
          {sideItems.map(({ id, label, icon: Icon, onClick, active }) => (
            <button key={id} data-testid={`sidenav-${id}`} onClick={onClick} className={`sara-navitem ${active ? "is-active" : ""}`}>
              <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
              <span>{label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div data-testid="sidebar-status" className="glass-card rounded-xl px-3 py-2.5 flex items-center gap-2.5">
        <span className={`h-2 w-2 rounded-full ${saraReady ? "bg-emerald-400 shadow-[0_0_8px_rgba(16,185,129,0.8)]" : "bg-amber-400"}`} />
        <div className="leading-tight">
          <div className="text-[11px] font-medium text-slate-200">Système {saraReady ? "en ligne" : "…"}</div>
          <div className="text-[10px] text-slate-500">SARA est prête</div>
        </div>
      </div>
    </aside>
  );
}

export default AppNav;
